import {
  ERROR_OTP_ALREADYSENT,
  ERROR_OTP_USERBLOCKED,
} from 'components/OtpModal/OtpModal.config';
import {
  RefreshCTA,
  RefreshText,
} from 'components/OtpModal/partials/style/OtpModalBody.style';
import { useFormikContext } from 'formik';
import { throttle } from 'lodash-es';
import { useEffect, useState } from 'react';
import { Translate } from 'react-localize-redux';
import { useDispatch, useStore } from 'react-redux';
import apiRequest from 'services/api/api.config';
import { unprocessableEntity_422 } from 'services/api/api.statusCodes';
import {
  resetOtpErrorsAction,
  setOtpStateAction,
} from 'services/otp/otp.actions';
import { makeSelectPostContractOtpGenerateApiConfig } from 'services/otp/otp.selectors';
import { selectUserProfile } from 'services/user/user.selectors';

export default function RefreshOtpLabel() {
  const reduxStore = useStore();
  const reduxState = reduxStore.getState();
  const dispatch = useDispatch();

  const {
    accessData: { phonePrefix, phoneNumber },
  } = selectUserProfile(reduxState);

  const [isRefreshAvailable, setIsRefreshAvailable] = useState(false);

  const formikContext = useFormikContext();

  useEffect(() => {
    let intervalId: ReturnType<typeof setInterval> | null = null;

    if (!isRefreshAvailable) {
      let tl = 10;
      intervalId = setInterval(() => {
        if (tl > 1) {
          --tl;
        } else {
          setIsRefreshAvailable(true);
        }
      }, 1_050);
    } else {
      if (intervalId) clearInterval(intervalId);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [isRefreshAvailable]);

  const resendCodeHandler = async () => {
    const generateOtpConfig = makeSelectPostContractOtpGenerateApiConfig({
      phonePrefix,
      phoneNumber,
    })(reduxState);
    setIsRefreshAvailable(false);
    formikContext.resetForm();
    dispatch(resetOtpErrorsAction);

    try {
      const response = await apiRequest.request(
        generateOtpConfig.requestConfig,
      );
      dispatch(
        setOtpStateAction({
          hasError: false,
          errorInfos: {},
          hintText: 'text.otp.codeSentOnPhone',
          counterRefresh: response.data.counterRefresh,
          counterCheck: 0,
        }),
      );
    } catch (fetchError) {
      if (fetchError?.response?.status === unprocessableEntity_422) {
        const errorInfos = fetchError.response.data?.error?.errorInfos;

        if (errorInfos.generic) {
          const isUserBlocked = errorInfos.generic[0] === ERROR_OTP_USERBLOCKED;
          const isGenerateAlreadyValid =
            errorInfos.generic[0] === ERROR_OTP_ALREADYSENT;

          dispatch(
            setOtpStateAction({
              hasError: !isGenerateAlreadyValid,
              hintText: isGenerateAlreadyValid
                ? 'text.otp.codeSentOnPhone'
                : '',
              errorInfos: isGenerateAlreadyValid
                ? {}
                : fetchError.response.data.error.errorInfos,
              counterCheck: fetchError.response.data.counterCheck ?? 4,
              counterRefresh: isUserBlocked ? 4 : undefined,
            }),
          );
        }
      }
    }
  };

  const throttleResendCodeHandler = throttle(resendCodeHandler, 2000, {
    trailing: false,
  });

  if (!isRefreshAvailable) {
    return null;
  }

  return (
    <RefreshText>
      <span>
        <Translate id="lbl.otp.codeNotReceived" />
      </span>
      <RefreshCTA onClick={throttleResendCodeHandler}>
        <Translate id="lbl.otp.sendNewCode" />
      </RefreshCTA>
    </RefreshText>
  );
}
